export enum InsurerNameEnum {
  Direct = 'direct',
  Wiener = 'Compensa (pod marką „Wiener”)',
}
